var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0201 8.72754C9.68759 8.72754 9.3687 8.85963 9.13357 9.09475C8.89845 9.32988 8.76636 9.64877 8.76636 9.98129C8.76636 10.3138 8.89845 10.6327 9.13357 10.8678C9.3687 11.1029 9.68759 11.235 10.0201 11.235H19.9576C20.2901 11.235 20.609 11.1029 20.8441 10.8678C21.0793 10.6327 21.2114 10.3138 21.2114 9.98129C21.2114 9.64877 21.0793 9.32988 20.8441 9.09475C20.609 8.85963 20.2901 8.72754 19.9576 8.72754H10.0201Z",
    fill: "#2E9CDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.77002 15C8.77002 14.31 9.32877 13.7462 10.02 13.7462H19.9575C20.29 13.7462 20.6089 13.8783 20.8441 14.1134C21.0792 14.3486 21.2113 14.6675 21.2113 15C21.2113 15.3325 21.0792 15.6514 20.8441 15.8865C20.6089 16.1216 20.29 16.2537 19.9575 16.2537H10.02C9.32877 16.2537 8.77002 15.6912 8.77002 15Z",
    fill: "#2E9CDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0312 18.765C9.69855 18.765 9.37949 18.8972 9.14425 19.1324C8.90901 19.3677 8.77686 19.6867 8.77686 20.0194C8.77686 20.3521 8.90901 20.6711 9.14425 20.9064C9.37949 21.1416 9.69855 21.2738 10.0312 21.2738H19.9687C20.3014 21.2738 20.6205 21.1416 20.8557 20.9064C21.0909 20.6711 21.2231 20.3521 21.2231 20.0194C21.2231 19.6867 21.0909 19.3677 20.8557 19.1324C20.6205 18.8972 20.3014 18.765 19.9687 18.765H10.0312Z",
    fill: "#2E9CDB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 7.5C3.75 6.50544 4.14509 5.55161 4.84835 4.84835C5.55161 4.14509 6.50544 3.75 7.5 3.75H22.5C23.4946 3.75 24.4484 4.14509 25.1517 4.84835C25.8549 5.55161 26.25 6.50544 26.25 7.5V22.5C26.25 23.4946 25.8549 24.4484 25.1517 25.1517C24.4484 25.8549 23.4946 26.25 22.5 26.25H7.5C6.50544 26.25 5.55161 25.8549 4.84835 25.1517C4.14509 24.4484 3.75 23.4946 3.75 22.5V7.5ZM7.5 6.25H22.5C22.8315 6.25 23.1495 6.3817 23.3839 6.61612C23.6183 6.85054 23.75 7.16848 23.75 7.5V22.5C23.75 22.8315 23.6183 23.1495 23.3839 23.3839C23.1495 23.6183 22.8315 23.75 22.5 23.75H7.5C7.16848 23.75 6.85054 23.6183 6.61612 23.3839C6.3817 23.1495 6.25 22.8315 6.25 22.5V7.5C6.25 7.16848 6.3817 6.85054 6.61612 6.61612C6.85054 6.3817 7.16848 6.25 7.5 6.25Z",
    fill: "#2E9CDB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -0.25,
    y: -0.25,
    width: 30.5,
    height: 30.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuOpen);
export default __webpack_public_path__ + "static/media/menuOpen.db3319ac800fb5b61413f37de05aa8fb.svg";
export { ForwardRef as ReactComponent };